export class ChangePasswordModel {
  public personHashId: string;
  public oldPassword: string;
  public newPassword: string;
  public confirmPassword: string;

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/userprofile/models/changepassword.model.ts